import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Smile, Shield, Home } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: MessageCircle,
    text: 'Más conversaciones reales'
  }, {
    icon: Smile,
    text: 'Menos discusiones por el celular'
  }, {
    icon: Shield,
    text: 'Mayor claridad en límites'
  }, {
    icon: Home,
    text: 'Mejor ambiente familiar'
  }];
  return <section className="py-8 bg-[#1a1a2e] text-white" data-id="element-21">
      <div className="container mx-auto px-4" data-id="element-22">
        <div className="flex flex-col md:flex-row items-center gap-6 max-w-6xl mx-auto" data-id="element-23">
          <div className="flex-1" data-id="element-24">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold mb-3 font-montserrat leading-tight" data-id="element-25">
              Imagina lograr esto <br data-id="element-26" />
              <span className="text-[#0ABFBC]" data-id="element-27">en tu propia casa:</span>
            </motion.h2>
            <p className="text-gray-300 text-lg mb-4" data-id="element-28">
              Pequeños cambios estratégicos pueden generar grandes mejoras en la
              convivencia diaria.
            </p>
          </div>

          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 w-full" data-id="element-29">
            {benefits.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/5 hover:bg-white/15 transition-colors flex items-center gap-4" data-id="element-30">
                <item.icon className="w-7 h-7 text-[#F97316] flex-shrink-0" data-id="element-31" />
                <h3 className="font-semibold text-base leading-tight" data-id="element-32">
                  {item.text}
                </h3>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}